export default __webpack_public_path__ + "static/media/yeongsam_crop_resize.48aeb562.jpg";